import { render } from "@testing-library/react";
import dayjs from "dayjs";
import ToolTip from "../../ToolTip/ToolTip";
import { Box, Typography } from "@mui/material";

export const academicCalendarTableHeader = [
    {
      field: "session_date",
      headerName: "Scheduled Date",
      width: 150,
    //   renderCell: (params) => dayjs(params.row.session_date).format("MMMM D, YYYY ")
    },
    {
      field: "from_time",
      headerName: "Start Time",
      width: 100,
      renderCell: (params) => dayjs(params.row.from_time, "HH:mm:ss").format("hh:mm A")
    },
    {
        field: "to_time",
        headerName: "End Time",
        width: 100,
        renderCell: (params) => dayjs(params.row.to_time, "HH:mm:ss").format("hh:mm A")
      },
    {
        field: "topic",
        headerName: "Topic",
        width: 350,
        renderCell: (params) => {
          const academicData = params.row.academic_calendar_data;
          if (!academicData) return "N/A";
          
          return (
            <ToolTip
              expand={`Chapter: ${academicData.chapter || 'N/A'}\nTopic: ${academicData.topic || 'N/A'}\nObjectives: ${academicData.objectives || 'N/A'}`}
              content={
                <Box sx={{ whiteSpace: 'pre-line' }}>
                  <Typography variant="body2"><strong>Chapter:</strong> {academicData.chapter || 'N/A'}</Typography>
                  <Typography variant="body2"><strong>Topic:</strong> {academicData.topic || 'N/A'}</Typography>
                  <Typography variant="body2"><strong>Objectives:</strong> {academicData.objectives || 'N/A'}</Typography>
                </Box>
              }
            />
          );
        }
      },
    {
      field: "rescheduled_at",
      headerName: "Rescheduled At",
      width: 200,
      renderCell: (params) => dayjs(params.row.rescheduled_at).format("MMMM D, YYYY hh:mm A")

    },

    {
        field: "reschedule_requested_by",
        headerName: "Rescheduled By",
        width: 150,
        renderCell: (params) => params.row.reschedule_requested_by==1 ? "Parent" : "Tutor"
    },
    {
        field: "rescheduled_reason",
        headerName: "Rescheduled Reason",
        width: 450,
        renderCell: (params) => {
            return(
            <ToolTip
                expand={params?.row?.rescheduled_reason || "Nill"}
                content={params?.row?.rescheduled_reason || "Nill"} />
            )
         
        }
      },
  ];
  